import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const painPoints = ['Duermes mal casi todas las noches y te despiertas con calor, ansiedad o agotamiento constante.', 'Sientes que tu cuerpo cambió sin previo aviso. Te notas más inflamada, has aumentado de peso y nada te queda como antes.', 'Tu mente no responde igual. Olvidas cosas simples, te cuesta concentrarte y vives con niebla mental.', 'Tu energía desapareció. Actividades que antes eran fáciles ahora te agotan.', 'Te miras al espejo y no te reconoces. Tu piel cambió, tu abdomen se siente más rígido y percibes un envejecimiento acelerado.', 'Vives con molestias físicas nuevas: articulaciones rígidas, piernas pesadas, hinchazón constante.', 'Sientes que nadie comprende lo que estás viviendo y te dicen que "es normal", pero tú sabes que necesitas una solución real.'];
export function PainPoints() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 px-4 bg-white" ref={ref} data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-3xl md:text-4xl font-bold text-center text-[#2D2926] mb-12" data-id="element-90">
          ESTE LIBRO ES PARA TI SI…
        </motion.h2>

        <div className="space-y-4" data-id="element-91">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 bg-[#B85C5C]/5 rounded-lg border-l-4 border-[#B85C5C]" data-id="element-92">
              <XCircleIcon className="w-6 h-6 text-[#B85C5C] flex-shrink-0 mt-0.5" data-id="element-93" />
              <p className="text-[#2D2926]/90 leading-relaxed" data-id="element-94">{point}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}